import React from "react";
import * as colors from "../../styles/colors";

const iconStyle = {
  display: "inline-block",
  verticalAlign: "-3px",
};

const CheckIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke={colors.primary}
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Yes"
    role="img"
    style={iconStyle}
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const XIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke={colors.accent}
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="No"
    role="img"
    style={iconStyle}
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

/**
 * Parses markdown links [text](url), **bold**, <CrownPrice />, :check:, and :x:
 * in a string and returns React elements. Non-matching text is returned as-is.
 */
export function parseMarkdownLinks(text, { crownPrice } = {}) {
  if (typeof text !== "string") return text;

  const parts = [];
  const regex = /\[([^\]]+)\]\(([^)]+)\)|\*\*([^*]+)\*\*|<CrownPrice\s*\/>|:check:|:x:/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    if (match[0] === ":check:") {
      parts.push(<CheckIcon key={match.index} />);
    } else if (match[0] === ":x:") {
      parts.push(<XIcon key={match.index} />);
    } else if (match[0] === "<CrownPrice />" || match[0] === "<CrownPrice/>") {
      if (crownPrice) {
        const num = Math.round(parseFloat(crownPrice));
        parts.push(`$${num.toLocaleString("en-US")}`);
      } else {
        parts.push("see pricing");
      }
    } else if (match[1] && match[2]) {
      const isExternal = match[2].startsWith("http");
      const DOFOLLOW = ["tinylog.app"];
      const isDofollow = DOFOLLOW.some((d) => match[2].includes(d));
      parts.push(
        <a
          key={match.index}
          href={match[2]}
          {...(isExternal
            ? { target: "_blank", rel: isDofollow ? undefined : "nofollow noreferrer" }
            : {})}
        >
          {match[1]}
        </a>
      );
    } else if (match[3]) {
      parts.push(<strong key={match.index}>{match[3]}</strong>);
    }

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length === 1 && typeof parts[0] === "string" ? parts[0] : parts;
}
